export const AUTH_TYPES = {
  IP: 'ip',
  URL: 'url',
  OPENATHENS: 'openathens',
};
